/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import s from "./Spinner.module.css";
import { FC } from "react";

type Props = {
  className?: string
  size?: "lg" | "sm"
  variant?: "gray" | "blue"
}

const Spinner: FC<Props> = ({ className, size = "lg", variant = "gray" }) => {
  const sizeClass = s[size];
  return (
    <div className={cn(className, "z-[1]")}>
      <span className={cn(s.loader, sizeClass, s[variant])} />
    </div>
  );
};

export default Spinner;
